import { Grid, Stack } from "@mui/material";
import Version from "./filters/Version.component";
import ExchangeProfile from "./filters/ExchangeProfile.component";
import Indicators from "./filters/Indicators.component";
import { type useForm, Controller } from "react-hook-form";

export interface CreateValidatedQuestionFiltersPropTypes {
    control: any;
    errors: ReturnType<typeof useForm>["formState"]["errors"];
    version: string;
    exchangeProfiles: { title: string; source: string }[];
    exchangeProfilesLoading: boolean;
    exchangeProfile: string;
    selectedIndicators: string[];
}

export const CreateValidatedQuestionFilters = ({
    exchangeProfiles,
    exchangeProfilesLoading,
    exchangeProfile,
    control,
    errors,
    selectedIndicators,
    version,
}: CreateValidatedQuestionFiltersPropTypes) => {
    return (
        <Grid size={{ xs: 12, md: 4 }}>
            <Stack gap={2}>
                <Controller
                    control={control}
                    name="exchangeProfile"
                    render={({ field: { onChange, onBlur } }) => {
                        return (
                            <ExchangeProfile
                                // @ts-ignore we should generate types from the swagger endpoint
                                exchangeProfiles={exchangeProfiles}
                                loading={exchangeProfilesLoading}
                                onChange={onChange}
                                onBlur={onBlur}
                                errors={errors}
                                step={1}
                            />
                        );
                    }}
                />

                <Controller
                    control={control}
                    name="version"
                    render={({ field: { onChange, onBlur } }) => {
                        return (
                            <Version
                                onChange={onChange}
                                onBlur={onBlur}
                                exchangeProfile={exchangeProfile}
                                errors={errors}
                                step={2}
                            />
                        );
                    }}
                />
                <Controller
                    control={control}
                    name="indicators"
                    disabled={!version}
                    render={({ field: { onChange, onBlur } }) => {
                        return (
                            <Indicators
                                onChange={onChange}
                                onBlur={onBlur}
                                selectedIndicators={selectedIndicators}
                                version={version}
                                exchangeProfile={exchangeProfile}
                                errors={errors}
                                step={3}
                            />
                        );
                    }}
                />
            </Stack>
        </Grid>
    );
};

export default CreateValidatedQuestionFilters;
